import { useTranslation } from "react-i18next";
import Button from "components/Button";
import HollowButton from "components/HollowButton";
import styles from "./styles.module.scss";
import { useWizard } from "./WizardContext";

interface Props {
  finishLabelKey?: string;
  onFinish?: () => void;
  disableNext?: boolean;
  /** Tryb autonomiczny: "Zapisz" bez nawigacji między krokami. */
  autonomous?: boolean;
}

const WizardActions = ({
  finishLabelKey = "common.finish",
  onFinish,
  disableNext = false,
  autonomous = false,
}: Props) => {
  const { t } = useTranslation();
  const {
    goBack,
    goNext,
    finish,
    isSaving,
    stepDirty,
    isFirstStep: isFirst,
    isLastStep: isLast,
  } = useWizard();

  if (autonomous) {
    return (
      <div className={styles.stepActions}>
        <Button
          text={t("common.save")}
          onClick={onFinish ?? finish}
          disabled={disableNext}
          loading={isSaving}
        />
      </div>
    );
  }

  return (
    <div className={styles.stepActions}>
      {!isFirst && <HollowButton text={t("common.back")} onClick={goBack} />}
      <Button
        text={isLast ? t(finishLabelKey) : t("common.save")}
        onClick={isLast ? onFinish ?? goNext : goNext}
        disabled={disableNext || (!isLast && !stepDirty)}
        loading={isSaving && isLast}
      />
    </div>
  );
};

export default WizardActions;
